import {
    SET_SECTIONS, SET_CONTRIBUTOR
} from './actionTypes'

export const setSections = (sections) => {
    return {
        type: SET_SECTIONS,
        sections
    }
}

export const setContributor = (data) => {
    return {
        type: SET_CONTRIBUTOR,
        data
    }
}